/**
 * Setup-wizard class strings — now Square / Mono.
 *
 * These names are kept so the five consumers (TrackIndex, CycleSetupWizard,
 * WorkflowSetupWizard, TemplateSetupWizard, CycleStrategicContextSection) do
 * not each need editing; the VALUES now come from the shared vocabulary in
 * @/components/mono/primitives. Converting this one file moved all five
 * surfaces off the rounded/gray system at once.
 *
 * Prefer importing the primitives directly in new code. This module exists to
 * carry the existing call sites across, not to be a second vocabulary.
 *
 * Cascade note: `.dark *` sets border-color to var(--rule) and comes after
 * Tailwind's plain classes, so a plain border-colour class loses in dark mode
 * (only an inline style or a `dark:` class wins). Everything here
 * uses the neutral rule (where that override is a no-op) and expresses state
 * through TEXT and BACKGROUND, which have no such override. Anything needing a
 * genuinely semantic border must use the primitives' `chip`/`panel`, which set
 * borderColor inline.
 */
import { BTN_BASE, FOCUS_RING, LABEL_MONO } from '@/components/mono/primitives';

export const wizardShell = 'min-h-full bg-[var(--bg)]';

export const wizardHeaderBar = 'border-b border-[var(--rule)] bg-[var(--bg-raised)]';

export const wizardCard = 'border border-[var(--rule)] bg-[var(--bg-raised)]';

export const wizardCardPad = `${wizardCard} p-5 sm:p-6`;

export const wizardSectionTitle = LABEL_MONO;

export const wizardSectionDesc = 'text-xs text-[var(--text-sec)] mt-1';

export const wizardInput =
  `w-full border border-[var(--rule-bright)] bg-[var(--surface)] px-3 py-2 text-sm text-[var(--text-pri)] placeholder:text-[var(--text-dim)] ${FOCUS_RING}`;

export const wizardSelect = wizardInput;

export const wizardBtnPrimary =
  `${BTN_BASE} border-[var(--slate)] bg-[var(--slate)] text-white hover:opacity-90`;

export const wizardBtnSecondary =
  `${BTN_BASE} border-[var(--rule-bright)] text-[var(--text-ter)] hover:bg-[var(--hover-tint)] hover:text-[var(--text-pri)]`;

/* Step states: colour carried by text + tint, never by the border. */
export const wizardStepActive =
  'border-[var(--rule-bright)] bg-[var(--slate-dim)] text-[var(--text-sec)]';

export const wizardStepDone =
  'border-[var(--rule-bright)] bg-[var(--green-dim)] text-[var(--green)] dark:text-[var(--text-ter)]';

export const wizardStepPending =
  'border-[var(--rule)] bg-[var(--surface)] text-[var(--text-ter)]';
